import App from "./App.tsx";
import ScaComplete from "./ScaComplete.tsx";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/themeProvider.tsx";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "./index.css";
import "./sentry.ts";

export const queryClient = new QueryClient();

// Wrapper to choose what to render
// eslint-disable-next-line react-refresh/only-export-components
function RootSwitcher() {
  const path = window.location.pathname;

  if (path.startsWith("/sca-complete")) {
    return <ScaComplete />;
  }
  return <App />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-center" duration={30000} />
      <ThemeProvider>
        <RootSwitcher />
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>
);
